import { Component, OnInit, OnDestroy } from '@angular/core';
import { CupService } from '../../shared/services/cup.service';
import { SecureStorageService } from '../../secure-storage.service';
@Component({
    host: {
        '(document:click)': 'onProviderClick($event)',
    },
    selector: 'app-provider',
    templateUrl: './provider.component.html',
    styleUrls: ['./provider.component.css'],
    standalone: false
})
export class ProviderComponent implements OnInit, OnDestroy {
  public providerSelected = false;
  private providerSubscription: any;
  private retainPanelSubscription: any;
  public searchRefined = false;
  public checkIfInputClick = false;
  public providerPanelDetails = {
    openProviderSearchPanel: false,
  };

  constructor(private cupService: CupService,
    private secureStorage:SecureStorageService) {
    // this.isProviderSelected();
    // this.providerInputClick();
  }

  /*Check whether member is selected in order to disable the other controls*/
  public isProviderSelected() {
    if (JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('providerSelected'))) {
      this.providerSelected = true;
    }
    this.providerSubscription = this.cupService.selectedProvider.subscribe(data => {
      if (data) {
        this.providerSelected = true;
        this.secureStorage.setSecureInfoInSessionlStorage('providerSelected', JSON.stringify(this.providerSelected));
      }
    });

  }

  /*Expand/Collapse provider search panel*/
  public toggleProviderPanel() {
    this.providerPanelDetails.openProviderSearchPanel = !this.providerPanelDetails.openProviderSearchPanel;
  }

  /*Determine Input clicks*/
  private providerInputClick() {
    this.retainPanelSubscription = this.cupService.retainProviderPanelOnClick.subscribe(data => {
      this.checkIfInputClick = data;
      if (!this.checkIfInputClick) {
        this.providerPanelDetails.openProviderSearchPanel = data;
      }
    });
  }

  /*Determine document clicks*/
   onProviderClick($event) {
    if (this.checkIfInputClick) {
      this.checkIfInputClick = false;
      return;
    } else {
      this.providerPanelDetails.openProviderSearchPanel = false;
    }
  }

  ngOnInit() { }

  ngOnDestroy() {
    if (this.providerSubscription) {
      this.providerSubscription.unsubscribe();
    }
    if (this.retainPanelSubscription) {
      this.retainPanelSubscription.unsubscribe();
    }
    sessionStorage.removeItem('providerResults');
  }
}
